<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<ng-container *ngIf="!createEdit">
  <div class="grid align-items-center">
    <div class="col md:col-5">
      <span class="p-input-icon-left ml-auto w-full">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          class="w-full"
          #keywordFilter
          (input)="dt1.filterGlobal([keywordFilter.value], '')"
          placeholder="Cerca..." />
      </span>
    </div>
    <div class="col md:col-4">
      <!-- <app-input-registry-picker [frmControl]="regFilter"></app-input-registry-picker> -->
      <p-autoComplete
        [suggestions]="suggestedRegs"
        (completeMethod)="filterRegs($event)"
        field="name"
        id="id"
        dataKey="id"
        class="flex-grow-1"
        [emptyMessage]="'Nessun risultato trovato'"
        [formControl]="regFilterCtrl"
        [forceSelection]="true"
        [showClear]="true"
        (onClear)="dt1.filterGlobal([keywordFilter?.value], '')"
        styleClass="w-full"
        placeholder="Filtra per azienda...">
        <ng-template
          pTemplate="item"
          let-item>
          {{ item.name }}<br />
          <small
            >{{ item.address }} -
            <ng-container *ngIf="item.zip_code">{{ item.zip_code }}</ng-container>
            {{ item | registryPrint: 'comune' }} ({{ item | registryPrint: 'provincia' }})</small
          >
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="col md:col-3">
      <p-button
        (onClick)="openFormAddressBookModal()"
        styleClass="butt w-full"
        [rounded]="true"
        [disabled]="!canCreateNew"
        ><span>Crea nuovo</span>
      </p-button>
    </div>
  </div>

  <div class="tbl max-w-full">
    <p-table
      [value]="addresses"
      sortField="letter"
      sortMode="single"
      [scrollable]="true"
      scrollHeight="400px"
      rowGroupMode="subheader"
      groupRowsBy="letter"
      dataKey="id"
      #dt1
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [lazy]="true"
      [loading]="loading"
      (onLazyLoad)="loadAddresses($event)"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      [(selection)]="selectedAddresses"
      currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Nome</th>
          <th>Email</th>
          <th>Telefono</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="groupheader"
        let-c>
        <tr pRowGroupHeader>
          <td
            colspan="6"
            class="striped">
            <span class="font-bold ml-2">{{ c.letter | uppercase }}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-c
        let-rowIndex="rowIndex">
        <tr>
          <td *ngIf="pickerType !== 'radio'">
            <p-tableCheckbox [value]="c"></p-tableCheckbox>
          </td>
          <td *ngIf="pickerType === 'radio'">
            <p-radioButton
              [value]="c"
              [inputId]="c.id"
              name="selectedAddressBookControl"
              [formControl]="selectedAddressBookControl"></p-radioButton>
          </td>

          <td>{{ c.name }} {{ c.last_name }}</td>
          <td>
            {{ c.email || '-' }}
          </td>
          <td>
            {{ c.phone_number || '-' }}
          </td>
          <td>
            <i
              class="pi pi-pencil text-xs teal-text cursor-pointer"
              [pTooltip]="'Modifica contatto'"
              tooltipPosition="top"
              (click)="openFormAddressBookModal(c.id)"></i>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">Nessun contatto trovato.</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="modal-footer">
      <div class="flex justify-content-between">
        <p-button
          (onClick)="close()"
          icon="pi pi-times"
          [text]="true"
          styleClass="butt red"
          [rounded]="true"></p-button>
        <p-button
          icon="pi pi-plus"
          (onClick)="save()"
          styleClass="butt"
          [rounded]="true"></p-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="createEdit">
  <app-modal-address-book-form
    (closing)="formSubmitted($event)"
    [registry_end_customer_contact_id]="contactId"
    [registry_end_customer_id]="registry_id">
  </app-modal-address-book-form>
</ng-container>
